import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export function MobileCallBar() {
  const location = useLocation();
  
  // Hide on admin, login, thank-you, and dashboard pages only
  const hiddenPaths = ['/admin', '/thank-you', '/login', '/dashboard'];
  const shouldHide = hiddenPaths.some(path => location.pathname.startsWith(path));
  
  if (shouldHide) {
    return null;
  }

  // Handle phone click - fire conversion tracking
  const handlePhoneClick = () => {
    if (typeof window.trackPhoneClickConversion === 'function') {
      window.trackPhoneClickConversion();
    }
  };

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-primary shadow-[0_-4px_20px_rgba(0,0,0,0.3)]"
      data-testid="mobile-call-bar"
    >
      <div className="flex">
        {/* Primary: Call button - 60% width */}
        <a
          href="tel:+14147953610"
          onClick={handlePhoneClick}
          className="flex-[3] flex items-center justify-center gap-2 py-4 px-4 text-white font-barlow font-bold uppercase tracking-wider text-base bg-primary hover:bg-primary-600 active:bg-primary-700 transition-colors min-h-[56px]"
          data-testid="mobile-call-btn"
        >
          <Phone className="w-5 h-5 flex-shrink-0" />
          <span>Call (414) 795-3610</span>
        </a>
        
        {/* Secondary: Get Quote button - 40% width */}
        <Link
          to="/contact"
          className="flex-[2] flex items-center justify-center gap-2 py-4 px-4 text-primary font-barlow font-bold uppercase tracking-wider text-sm bg-accent hover:bg-accent-400 active:bg-accent-500 transition-colors min-h-[56px] border-l border-primary/20"
          data-testid="mobile-quote-btn"
        >
          <span>Free Quote</span>
          <ArrowRight className="w-4 h-4 flex-shrink-0" />
        </Link>
      </div>
    </div>
  );
}

// Height constant for padding calculations
export const MOBILE_CALL_BAR_HEIGHT = 56; // px - matches min-h-[56px]
